/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Dhananjay",
  title: "Hi all, I'm Dhananjay",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 and Blogger 📑 having an experience of building Web and Mobile applications with Flutter / Firebase / DotNet and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/18gmFGSAAqPSiQil6bL0i6BDdQT6BwLwh/view?usp=sharing ", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  medium: "https://medium.com/@dhananjay_1891",
  github: "https://github.com/dhananjay7781",
  linkedin: "https://www.linkedin.com/in/dhananjay7/",
  gmail: "dhananjaypatil9683@gmail.com",
  twitter: "https://twitter.com/_dhananjay7",
  instagram: "https://instagram.com/dhananjay_1891",
  // leetcode : "https://leetcode.com/dhananjay7781",
  // topmate : "https://topmate.io/dhananjay_patil",
  // facebook: "https://www.facebook.com/saad.pasta7",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    "⚡ Build robust Web APIs with .NET Core 6.0 and 8.0 frameworks",
    "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
    "⚡ Progressive Web Applications (PWA) in normal and SPA Stacks",
    "⚡ Integration of third-party services such as Firebase, Azure, and Go Daddy",
  ],

  softwareSkills: [
    { skillName: "C", imgPath: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg" },
    { skillName: "C#", imgPath: "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg" },
    { skillName: "Core Java", imgPath: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg" },
    { skillName: "Python", imgPath: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg" },
    { skillName: "Database", imgPath: "https://www.vectorlogo.zone/logos/postgresql/postgresql-icon.svg" },
    { skillName: "GraphQL", imgPath: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg" },
    { skillName: "Flutter", imgPath: "https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg" },
    { skillName: ".Net", imgPath: "https://www.vectorlogo.zone/logos/dotnet/dotnet-tile.svg" },
    { skillName: "VS Code", imgPath: "https://www.vectorlogo.zone/logos/visualstudio_code/visualstudio_code-icon.svg" },
    { skillName: "Git", imgPath: "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg" },
    { skillName: "GitLab", imgPath: "https://www.vectorlogo.zone/logos/gitlab/gitlab-icon.svg" },
    { skillName: "JIRA", imgPath: "https://www.vectorlogo.zone/logos/atlassian_jira/atlassian_jira-icon.svg" },
    { skillName: "Figma", imgPath: "https://www.vectorlogo.zone/logos/figma/figma-icon.svg" },
    { skillName: "Postman", imgPath: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" },
    { skillName: "Microsoft Azure", imgPath: "https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-icon.svg" },
    { skillName: "Firebase", imgPath: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" },
    { skillName: "Android Development", imgPath: "https://www.vectorlogo.zone/logos/android/android-icon.svg" },
    { skillName: "iOS Development", imgPath: "https://www.vectorlogo.zone/logos/apple/apple-tile.svg" },
    { skillName: "Linux", imgPath: "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg" },
    // { skillName: "REST APIs", imgPath: "https://www.vectorlogo.zone/logos/swaggerio/swaggerio-icon.svg" },
  ],
  display: true,
};


// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Pune, Pune",
      logo: require("./assets/images/puneunit.png"),
      subHeader: "Bachelor of Engineering in Electronics and Telecommunication",
      duration: "August 2019 - July 2023",
      desc: "CGPA - 8.13 (First class with Distinction)",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Shri Sant Damaji Mahavidyalay, Mangalwedha",
      logo: require("./assets/images/damaji.jpg"),
      subHeader: "HSC",
      duration: "July 2018 - February 2019",
      desc: "Percentage - 71.08%",
      //descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "75%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Associate Software Engineer",
      company: "Emerson",
      companylogo: require("./assets/images/emerson.png"),
      url : "https://www.emerson.com/en-in",
      date: "June 2024 – Present",
      desc: "In my current role with the development team of the product DCMlink, I am actively engaged in research and development as part of the New Product Development (NPD) team.",
      descBullets: [
        "My work focuses on leveraging a diverse range of technologies, including PostgreSQL, MongoDB, SQLite, Flutter, React Native, C#, .NET, and Microsoft Azure.",
        "I actively contribute to creating proofs of concept for Android and iOS applications, enabling innovation and enhancing project outcomes.",
        "I am also focused on understanding how products are developed from scratch, gaining insights into the Software Development Life Cycle (SDLC) with a strong emphasis on cybersecurity integration and customer-centric approaches, ensuring secure, high-quality solutions that meet user needs."
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Ellicium",
      companylogo: require("./assets/images/ellicium.png"),
      url : "https://ellicium.com/",
      date: "Mar 2023 – Jun 2024",
      desc: "As a key member of the SXR Enterprise Software development team,spearheaded API implementation and backend development processes.",
      descBullets: [
        "Architected and crafted a whole .Net Core Web App, leveraging the Repository Design Pattern to seamlessly connect with other web apps.Utilized .Net Core MVC and Entity Framework Core for robust development.",
        "Significantly improved API performance by optimizing response time from 40 seconds to 4 seconds through the implementation of caching mechanisms and the development of a custom stored procedure.",
        "Successfully integrated GraphQL into a .Net Core 3.1 web application, featuring dynamic filter and sort models, demonstrating exceptional optimization for enhanced performance.",
        "Actively participate in troubleshooting and resolving production issues to ensure seamless operation of the application."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Void Star India",
      companylogo: require("./assets/images/vsi.jpg"),
      url : "https://www.vsiedu.com/",
      date: "Dec 2022– Feb 2023",
      desc: "As a key member of the VSIEDU Software development team, spearheaded API implementation and backend development processes.",
      descBullets: [
        "Developed APIs and scalable backends for VSIEDU, implemented in C# and DotNet.",
        "Troubleshot and resolved backend issues, ensuring smooth application operation.",
        "VSIedu is E-learning platform for Students, Institutes, Industries to Collaborate, Educate, Innovate in this project, I implemented API’s using .Net core and used Microsoft Azure for cloud operations."
      ]
    },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Manastik",
    //   companylogo: require("./assets/images/manastik_logo.jpg"),
    //   date: "May 2022 – Aug 2022",
    //   desc: "In my current role with the development team of the product DADT-Dementia App for Diagnosis & Tracking, I actively engaged in research and development as well as frontend development",
    //   descBullets: [
    //     "Identified the hooks to re-design UI's and developed fully responsive UI's for an App Using Flutter SDK.",
    //     "Increased traffic and user retention by customizing UIs for future compatibilty of code and better experience for users.",
    //     "Developed fully responsive UI’s for an app using Flutter, added video player functionality, Created pages for doctor’s appointment and Login, SignUp screen also re-designed UI’s for better user experience."
    //   ]
    // },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME OF MY KEY PROJECTS",
  projects: [
    {
      image: require("./assets/images/whitelogo.png"),
      projectName: "Belly to baby photography",
      projectDesc: "I developed a fully responsive portfolio website for a photographer using Flutter, Firebase showcasing categories such as newborn, kids, and maternity photos. I have done whole development, conducted research and hosted the site on a custom domain via GoDaddy",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://bellytobabyphotography.in/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/college_guru.png"),
      projectName: "College Guru",
      projectDesc: "College Guru is an all-in-one app designed to help students appearing for MHT-CET, MBA CET, and Engineering admissions in Maharashtra. Whether you’re looking to predict your rank, discover suitable colleges, or get insights into top institutes, College Guru is your trusted guide.",
      footerLink: [
        {
          name: "Download App",
          url: "https://play.google.com/store/apps/details?id=com.dhananjay.college_guru"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Certificate of Appreciation at Emerson",
      subtitle:
        "Certificate of appreciation by Emerson for developing android and iOS app for Technology Day 2025 ",
      image: require("./assets/images/emerson_cert1.jpg"),
      imageAlt: "Certificate of Appreciation at Emerson",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.linkedin.com/in/dhananjay7/overlay/experience/2419055677/multiple-media-viewer/?profileId=ACoAAC4gwlMBVz321WssJ0wW5IhTeNGXWKBZ8uk&treasuryMediaId=1739283397290"
        }
      ]
    },
    {
      title: "Certificate of Teamwork at Manastik",
      subtitle:
        "Part of the team Manastik at MIT WPU Innovation Conclave 2022, Kothrud",
      image: require("./assets/images/manastik_ach.jpg"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1arTwrvggos6Kr2WoYFEKHT5a7p2yjiaV/view"
        },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Multi-OS Seminar by AstroMediComp",
      subtitle:
        "As an attendee of seminar conducted in Feb-2022.This Seminar covered installation of multiple operating systems on one assembled hard disk",
      image: require("./assets/images/multios.jpg"),
      imageAlt: "Multi-OS Seminar by AstroMediComp",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/drive/u/0/folders/1yQvJ2VdXr3ETYRPdPu39ti6yQqGR0WvC"
        }
      ]
    },

    {
      title: "Cutshort Advance Java",
      subtitle: "Completed Certifcation from Cutshort for Advance Java",
      image: require("./assets/images/cutshort.jpg"),
      imageAlt: "Cutshort Certificate",
      footerLink: [
        { name: "Certification", url: "https://cutshort.io/certificate/59224" },
        // {
        //   name: "Final Project",
        //   url: "https://pakistan-olx-1.firebaseapp.com/"
        // }
      ]
    },
    // {
    //   title: "Blogger at Medium",
    //   subtitle: "In my Medium blogging account that garners nearly 2,000 views monthly with a read ratio exceeding 60%, showcasing expertise in technical content writing and audience engagement. ",
    //   image: require("./assets/images/medium_ach.jpg"),
    //   imageAlt: "Cutshort Certificate",
    //   footerLink: [
    //     { name: "Certification", url: "https://cutshort.io/certificate/59224" },
    //     // {
    //     //   name: "Final Project",
    //     //   url: "https://pakistan-olx-1.firebaseapp.com/"
    //     // }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7378969795",
  email_address: "dhananjaypatil9683@gmail.com",
  display: true
};

// Twitter Section

const twitterDetails = {
  userName: "@_dhananjay7", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
